import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTransactions, useUI, useAuth } from '../hooks';
import PaymentWizard from '../components/PaymentWizard';
import { Transaction } from '../types';

const PaySomeoneScreen: React.FC = () => {
  const navigate = useNavigate();
  const { showToast } = useUI();
  
  // Handle form submission
  const handleSubmit = async (data: {
    totalAmount: string;
    originalAmount: string;
    platformFee: string;
    publicUserId: string;
    sellerId: string;
    itemId: string;
    paymentMethod: string;
    transactionId?: string;
  }) => {
    try {
      if (data.transactionId) {
        // Payment was already processed by Stripe and transaction was created by the backend
        showToast('success', `Payment of $${data.totalAmount} submitted successfully!`);
        navigate(`/payment/${data.transactionId}`);
      } else {
        // This branch should not be executed in the new flow
        // as transactions are created by the backend after payment confirmation
        showToast('error', 'Invalid payment flow. Please try again.');
      }
    } catch (error) {
      showToast('error', 'Failed to process payment. Please try again.');
    }
  };
  
  return (
    <div className="container">
      <PaymentWizard onSubmit={handleSubmit} />
    </div>
  );
};

export default PaySomeoneScreen;